import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import {
  LucideAngularModule,
  MailIcon,
  PhoneIcon,
  ShieldIcon,
  CheckCircleIcon,
} from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { BannerPrincipalBaterias } from './servicio-baterias/banner-principal-baterias';
import { EncuentraLaBateriaCorrecta } from './servicio-baterias/encuentra-la-bateria-correcta';
import { FaqsBaterias } from './servicio-baterias/faqs-baterias';
import { NecesitasAyudaConTuBateria } from './servicio-baterias/necesitas-ayuda-con-tu-bateria';
import { SeleccionaLaBateria } from './servicio-baterias/selecciona-la-bateria';
import { ServicioBaterias } from './servicio-baterias/servicios-baterias';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-diagnostico-instalacion-baterias',
  imports: [
    CommonModule,
    MainLayout,
    LucideAngularModule,
    MarginWrapper,
    BannerPrincipalBaterias,
    EncuentraLaBateriaCorrecta,
    FaqsBaterias,
    NecesitasAyudaConTuBateria,
    SeleccionaLaBateria,
    ServicioBaterias,
  ],
  template: `<allas-main-layout>
    <allas-margin-wrapper styleClass="bg-white">
      <!-- Titulo Programa de Recompensas -->
      <h1 class="xl:text-4xl my-2 xl:my-4 font-medium fs-condensed">
        PRUEBA, CARGA E INSTALACIÓN GRATUITA DE BATERÍAS
      </h1>
      <allas-banner-principal-baterias></allas-banner-principal-baterias>
      <allas-servicio-baterias></allas-servicio-baterias>
      <allas-encuentra-la-bateria-correcta></allas-encuentra-la-bateria-correcta>
      <allas-faqs-baterias></allas-faqs-baterias>
      <allas-necesitas-ayuda-con-tu-bateria></allas-necesitas-ayuda-con-tu-bateria>
      <allas-selecciona-la-bateria></allas-selecciona-la-bateria>
    </allas-margin-wrapper>
  </allas-main-layout>`,
})
export class DiagnosticoInstalacionBaterias implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle =
      'Diagnóstico e Instalación de Baterías Gratis | Allas Repuestos';
    const description =
      'Servicio gratuito de diagnóstico, carga e instalación de baterías TAB en Honduras. Técnicos certificados y envío a domicilio incluido.';
    const keywords =
      'baterías, diagnóstico baterías, instalación baterías, carga baterías, TAB, Honduras, Allas Repuestos, envío a domicilio, garantía, técnicos certificados';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
